import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

const MIN_FIRE_INTERVAL_MS = 1000

export default class extends Controller {
  static targets = ["display"]
  static values = { deadline: String, mode: String, tickUrl: String, tickSound: Boolean }
  static classes = ["urgent"]

  connect() {
    this.lastFiredAt = 0
    this.lastTickSecond = null
    this.render()
    this.timer = setInterval(() => this.render(), 100)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const left = (Date.parse(this.deadlineValue) - Date.now()) / 1000

    if (this.hasDisplayTarget) {
      const seconds = Math.max(Math.ceil(left), 0)
      this.displayTarget.textContent = seconds
      if (this.hasUrgentClass) {
        this.urgentClasses.forEach((name) => this.displayTarget.classList.toggle(name, left <= 5 && left > 0))
      }
      this.maybeTick(seconds)
    }

    if (left <= 0) {
      const now = Date.now()
      if (now - this.lastFiredAt < MIN_FIRE_INTERVAL_MS) return

      this.lastFiredAt = now
      if (this.modeValue === "reload") {
        window.Turbo.visit(window.location.href, { action: "replace" })
      } else if (this.hasTickUrlValue) {
        post(this.tickUrlValue)
      }
    }
  }

  maybeTick(seconds) {
    if (!this.tickSoundValue) return
    if (seconds < 1 || seconds > 5) {
      this.lastTickSecond = null
      return
    }
    if (seconds === this.lastTickSecond) return

    // The display shows Math.ceil(left); tie the beep to that same digit
    // change so audio and number flip together instead of drifting within
    // the 250ms sample window.
    this.lastTickSecond = seconds
    if (localStorage.getItem("duels:sound") !== "on") return

    this.beep(seconds === 1 ? 1046 : 660, seconds === 1 ? 0.28 : 0.12)
  }

  beep(frequency, duration) {
    try {
      const context = new (window.AudioContext || window.webkitAudioContext)()
      const now = context.currentTime
      const gain = context.createGain()
      gain.gain.setValueAtTime(0.12, now)
      gain.gain.exponentialRampToValueAtTime(0.001, now + duration)
      gain.connect(context.destination)
      const osc = context.createOscillator()
      osc.frequency.value = frequency
      osc.connect(gain)
      osc.start(now)
      osc.stop(now + duration)
    } catch {
      return
    }
  }
}
